export const allowedBlogTags = [
	'astro',
	'linux',
	'javascript',
	'security',
	'nodejs',
	'homelab',
	'bash',
	'interview',
	'engineering',
	'competition',
	'cloudflare',
	'database',
	'devops',
	'docker',
	'oss',
	'overthewire',
	'git',
	'gatsby',
	'nextjs',
	'postgres',
	'raspberrypi',
	'react',
	'golang',
	'projects',
	'performance',
	'personal',
	'selfhosted',
	'system design',
	'networking',
];

export const recentPostsLimit = 3;

export const BOT_FIELD_NAME = 'name';

export const heroImages = [
	{
		jpg: '/static/images/hero-image-2.jpg',
		webp: '/static/images/hero-image-2.webp',
	},
	{
		jpg: '/static/images/hero-image-3.jpg',
		webp: '/static/images/hero-image-3.webp',
	},
	{
		jpg: '/static/images/hero-image-4.jpg',
		webp: '/static/images/hero-image-4.webp',
	},
	{
		jpg: '/static/images/hero-image-1.jpg',
		webp: '/static/images/hero-image-1.webp',
	},
	{
		jpg: '/static/images/hero-image-9.jpg',
		webp: '/static/images/hero-image-9.webp',
	},
	{
		jpg: '/static/images/hero-image-5.jpg',
		webp: '/static/images/hero-image-5.webp',
	},
	{
		jpg: '/static/images/hero-image-7.jpg',
		webp: '/static/images/hero-image-7.webp',
	},
	{
		jpg: '/static/images/hero-image-6.jpg',
		webp: '/static/images/hero-image-6.webp',
	},
	{
		jpg: '/static/images/hero-image-8.jpg',
		webp: '/static/images/hero-image-8.webp',
	},
];

export const GITHUB_PUBLIC_REPOS_URL =
	'https://api.github.com/users/AkashRajpurohit/repos?affiliation=owner&visibility=public&sort=updated&per_page=100';

// export const githubProjectIds = [
// 	613008621, // 'time-to-go'
// 	640499782, // 'ts-npm-template'
// 	606340527, // 'easy-gif'
// 	242763864, // 'clipper'
// 	591608314, // 'dotfiles'
// 	640252129, // 'snowflake-id'
// 	565033847, // 'the-office-api'
// 	211795133, // 'Spell-IT'
// 	164105224, // 'boilerplate-gen'
// 	654213730, // 'email-server'
// 	698230588, // 'wormhole',
// 	487216481, // 'howtoprofessionallysay'
// ];

export const githubProjects = [
	'time-to-go',
	'ts-npm-template',
	'easy-gif',
	'clipper',
	'dotfiles',
	'snowflake-id',
	'the-office-api',
	'spell-it',
	'boilerplate-gen',
	'email-server',
	'wormhole',
	'howtoprofessionallysay',
	'utils',
	'giffy',
	'remark-add-query-param',
	'git-sync',
	'go-react-typescript-template',
	'quick-notes',
];

export const resumeCompanies = [
	{
		company: 'Levels.fyi',
		title: 'Senior Software Engineer',
		logo: '/static/images/resume/logos/levels.fyi.png',
		start: 'Oct 2024',
		end: 'Present',
	},
	{
		company: 'Postman',
		title: 'Software Engineer II',
		logo: '/static/images/resume/logos/postman.png',
		start: 'June 2022',
		end: 'Oct 2024',
	},
	{
		company: 'Cimpress',
		title: 'Software Engineer',
		logo: '/static/images/resume/logos/cimpress.png',
		start: 'April 2021',
		end: 'June 2022',
	},
	{
		company: 'PeopleGrove',
		title: 'Software Engineer',
		logo: '/static/images/resume/logos/peoplegrove.png',
		start: 'August 2020',
		end: 'April 2021',
	},
];
